import { UserStar } from 'lucide-react'

import { View } from '../../../components/view'
import { ViewFilterMenu, type ViewFilterOption } from '../../../components/view-filter-menu'
import type { ForYouFilterType } from '../for-you-filter'

const FILTER_OPTIONS: Array<ViewFilterOption<ForYouFilterType>> = [
  { value: 'staged', label: 'Drafts' },
  { value: 'all', label: 'All' },
  { value: 'completed', label: 'Completed' },
  { value: 'archived', label: 'Archived' },
]

interface ForYouViewHeaderProps {
  filter: ForYouFilterType
  onFilterChange: (filter: ForYouFilterType) => void
}

export function ForYouViewHeader({ filter, onFilterChange }: ForYouViewHeaderProps) {
  return (
    <View.Header
      icon={<UserStar />}
      title="For You"
      accessory={<ViewFilterMenu value={filter} options={FILTER_OPTIONS} subject="for-you" onChange={onFilterChange} />}
    />
  )
}
